import React from 'react'
import { Button, Tooltip, Popconfirm } from 'antd'
import { SaveOutlined, StopOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'

export const TableButtons = ({
  record,
  isEditing,
  save,
  editCancel,
  editingKey,
  edit,
  handleDelete,
}) => {
  const editable = isEditing(record)
  return editable ? (
    <div className="flex justify-between items-center">
      <Tooltip title="保存する">
        <Button
          size="small"
          onClick={() => save(record.Id, record)}
          style={{ marginRight: 8 }}
          className="lg:ml-4"
        >
          <SaveOutlined />
        </Button>
      </Tooltip>
      <Tooltip title="中止する">
        <Button size="small" danger onClick={editCancel} className="lg:mr-4">
          <StopOutlined />
        </Button>
      </Tooltip>
    </div>
  ) : (
    <div className="flex justify-between items-center">
      <Tooltip title="編集">
        <Button
          className="custom-button lg:ml-4"
          size="small"
          disabled={editingKey !== ''}
          onClick={() => edit(record)}
        >
          <EditOutlined />
        </Button>
      </Tooltip>
      <Popconfirm
        placement="left"
        disabled={editingKey !== ''}
        title="削除しますか？"
        onConfirm={() => handleDelete(record.Id)}
      >
        <Tooltip title="削除">
          <Button size="small" danger disabled={editingKey !== ''} className="lg:mr-4">
            <DeleteOutlined />
          </Button>
        </Tooltip>
      </Popconfirm>
    </div>
  )
}
